<app-kontable
  *ngIf="!dialogApplication"
  id="dt_company"
  title="{{ 'companyList.sectionTitle' | translate }}"
  [columns]="[
    { field: 'id', title: 'common.id', filterType: numberFilter },
    'name', 'host_code']"
  [titles]="['common.name', 'common.host_code']"
  [source]="srvCompany.companies"
  [showRecoverButton]="false"
  [showDetailsButton]="false"
  [showAddButton]="true"
  [showGlobalFilter]="false"
  [showInfoButton]="false"
  [additionalRowCommands]="customRow"
  [(fireNewDataAvailable)]="newDataAvailable"
  (onAdd)="showAddOrEditDialog($event)"
  (onEdit)="showAddOrEditDialog($event)"
  (onRemove)="delete($event)">
  <ng-template #customRow data-testid="customRow" let-row>
    <p-button label="" pTooltip="{{ 'common.applications' | translate }}" icon="fa fa-laptop" styleClass="ui-button-info" (onClick)="onCustomButton(row)"></p-button>
    <!--<p-button label="" pTooltip="{{'common.manageAssociations' | translate}}" icon="fa fa-bars" styleClass="ui-button-info" (onClick)="openAssociate(row)"></p-button>-->
  </ng-template>
</app-kontable>

<p-dialog
  *ngIf="showInfoModal"
  [(visible)]="showInfoModal"
  [modal]="true"
  header="{{modalTitle}}"
  [minWidth]="500"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDialog()">
  <app-company-form
    (companyAdded)="companyAdded($event)"
    (companyUpdated)="companyUpdated($event)"
    [dialogBoxCompany]="selectedCompany"
  ></app-company-form>
</p-dialog>

<app-company-applications
  *ngIf="dialogApplication"
  [selectedApplications]="selectedApplications"
  [activeCompany]="selectedCompany"
  (onBackPressed)="back()"
></app-company-applications>

<p-dialog
  *ngIf="showAssociateDialog"
  [(visible)]="showAssociateDialog"
  [modal]="true"
  header="{{'common.manageAssociations' | translate}} - {{company.name}}"
  [positionTop]="50"
  [minWidth]="700"
  [draggable]="false"
  [resizable]="false"
  (onHide)="showAssociateDialog=false">
  <app-associations origin="companies"></app-associations>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/company/companies.component.html